export const ADD_EXPENSES = 'ADD_EXPENSES';
export const UPDATE_EXPENSE = 'UPDATE_EXPENSE';
export const SET_CURRENCY_VIEW = 'SET_CURRENCY_VIEW';
export class AddExpenses {
    constructor(expenses) {
        this.expenses = expenses;
        this.type = ADD_EXPENSES;
    }
}
export class UpdateExpense {
    constructor(expense) {
        this.expense = expense;
        this.type = UPDATE_EXPENSE;
    }
}
export class SetCurrencyView {
    constructor(currencyView) {
        this.currencyView = currencyView;
        this.type = SET_CURRENCY_VIEW;
    }
}
